export const pickIndexByChance = chances => {
  const total = chances.reduce((sum, chance) => sum + chance, 0);
  const random = Math.random() * total;

  let cumulative = 0;
  for (let i = 0; i < chances.length; i++) {
    cumulative += chances[i];
    if (random < cumulative) {
      return i;
    }
  }
};
